module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Addresses","newLink":"+ New address"},"et":{"title":"Addresses","newLink":"+ New address"},"ru":{"title":"Addresses","newLink":"+ New address"}}')
  delete Component.options._Ctor
}
